export const AUTH_MUTATIONS = {
    UPDATE_USER: 'updateUser',
    UPDATE_USER_SETTINGS: 'updateUserSettings',
    USER_SETTINGS_LOADING: 'userSettingsLoading',
    UPDATE_SHAREABLE_USERS: 'updateShareableUsers',
}
export const HOME_MUTATIONS = {
    OVERWRITE_HOME_FORM: 'overwriteHomeForm',
    SET_HOME_TO_EDIT: 'setHomeToEdit',
    SET_PHOTO_DELETE_STATUS: 'setPhotoDeleteStatus',
    SET_AUTOFILLED_LOCATION: 'setAutofilledLocation',
    SET_AUTOFILL_STATUS: 'setAutofillStatus',
    SET_ADDRESS_SEARCH_COORDINATES: 'setAddrSearchCoords',
    SET_ADDRESS_SEARCH_STATUS: 'setAddrSearchStatus',
    SET_HOME_SUBMIT_STATUS: 'setHomeSubmitStatus',
    SET_HOME_DELETE_STATUS: 'setHomeDeleteStatus',
    SET_CREATED_HOME_ID: 'setCreatedHomeId',
    TOGGLE_EXTRA: 'toggleExtraFormItem',
    UPDATE_FORM_SECTION: 'updateFormSection',
    RESET_SUBMIT_STATUS: 'resetSubmitStatus',
}

export const SEARCH_MUTATIONS = {
    SET_SEARCH_STATUS: 'setSearchStatus',
    SET_SEARCH_RESULTS: 'setSearchResults',
    SET_MORE_TO_LOAD: 'setMoreToLoad',
    SET_NUM_SEARCH_RESULTS: 'setNumSearchResults',
    REMOVE_SEARCH_RESULT: 'removeSearchResult',
}

export const BLOG_MUTATIONS = {
    UPDATE_BLOG_POST_LIST: 'updateBlogPostList',
    SET_BLOG_STATUS: 'setBlogStatus',
    SET_POST_TO_EDIT: 'setPostToEdit',
}

export const blankAddHomeForm = {
    location: { label: 'Location', component: 'LocationForm' },
    selectDetails: { label: 'Choose Details', component: 'SelectDetails' },
    occupants: null,
    gad: null,
    census: null,
    structure: null,
    events: null,
    photos: null,
    references: null,
    review: { label: 'Review', component: 'ReviewDetailWrapper'},
    submit: { label: 'Submit', component: 'SubmitSection' },
}

